// extracted by mini-css-extract-plugin
export default {"header":"MobileHeader_header__rW8kn","headerLeft":"MobileHeader_headerLeft__V+Saz","headerRight":"MobileHeader_headerRight__J3yKu","headerEmpty":"MobileHeader_headerEmpty__w5FzM"};